import { IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router";

import { DogPersonGridDto, EDogSex, PersonApi, PersonDogsSearch } from "../../../../api";
import { EditButton } from "../../../../components";
import { useAuth } from "../../../../contexts";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { DrupalDataTable } from "../../../common";
import { DrupalFieldSet } from "../../../common/DurpalFieldSet";
import { EDrupalRoutes } from "../../../EDrupalRoutes";

export interface IDeadDogsProps {}

export const DeadDogs: React.FunctionComponent<IDeadDogsProps> = () => {
  const { user } = useAuth();
  const api = useApiService(PersonApi);
  const { t } = useTl();
  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: true,
    enableFilter: true,
    availablePageSizes: [5, 10, 15],
    pageSize: 5,
    sortKeys: { name: "ASC" },
  });
  const { totalCount } = tableState;
  const history = useHistory();
  const searchFunction = React.useCallback(
    (sObj?) => {
      const sobj = PersonDogsSearch.fromJS({
        ...sObj,
        personId: user.userId,
        hideDead: false,
      });
      return api.searchDogs(sobj);
    },
    [api, user.userId]
  );

  const { loading } = useSearchApi({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.Action),
        fieldName: "_action",
        computed: true,
        disableSorting: true,
        autoFitContent: true,
        alignment: "center",
        render: (row: DogPersonGridDto) => (
          <EditButton onClick={() => history.push(`${EDrupalRoutes.dog}/${row.dogId}/files`)} secured={false} />
        ),
      },
      {
        header: () => t(ETLCodes.CompleteName),
        fieldName: "name",
      },
      {
        header: () => t(ETLCodes.Breed),
        fieldName: "breedName",
      },
      {
        header: () => t(ETLCodes.Chip),
        fieldName: "dogChip",
      },
      {
        header: () => t(ETLCodes.Sex),
        fieldName: "sex",
        render: (row: DogPersonGridDto) => (row.sex === EDogSex.Female ? "F" : "M"),
      },
      {
        header: () => t(ETLCodes.BirthDate),
        fieldName: "birthDate",
      },
      {
        header: () => t(ETLCodes.DeathDate),
        fieldName: "deathDate",
      },
    ],
    [history, t]
  );

  return (
    <DrupalFieldSet title={`${t(ETLCodes.DeceasedDogs)} (${totalCount})`}>
      <DrupalDataTable tableState={tableState} loading={loading} columns={columns} />
    </DrupalFieldSet>
  );
};
